import { NFLTeamAbbreviation } from '../enums/nfl-abbreviations';

export const NFL_TEAM_NICKNAMES: Record<NFLTeamAbbreviation, string> = {
    [NFLTeamAbbreviation.NFL]: 'NFL',
    [NFLTeamAbbreviation.ARI]: 'Cardinals',
    [NFLTeamAbbreviation.ATL]: 'Falcons',
    [NFLTeamAbbreviation.BAL]: 'Ravens',
    [NFLTeamAbbreviation.BUF]: 'Bills',
    [NFLTeamAbbreviation.CAR]: 'Panthers',
    [NFLTeamAbbreviation.CHI]: 'Bears',
    [NFLTeamAbbreviation.CIN]: 'Bengals',
    [NFLTeamAbbreviation.CLE]: 'Browns',
    [NFLTeamAbbreviation.DAL]: 'Cowboys',
    [NFLTeamAbbreviation.DEN]: 'Broncos',
    [NFLTeamAbbreviation.DET]: 'Lions',
    [NFLTeamAbbreviation.GB]: 'Packers',
    [NFLTeamAbbreviation.HOU]: 'Texans',
    [NFLTeamAbbreviation.IND]: 'Colts',
    [NFLTeamAbbreviation.JAX]: 'Jaguars',
    [NFLTeamAbbreviation.KC]: 'Chiefs',
    [NFLTeamAbbreviation.LA]: 'Rams',
    [NFLTeamAbbreviation.LAC]: 'Chargers',
    [NFLTeamAbbreviation.LV]: 'Raiders',
    [NFLTeamAbbreviation.MIA]: 'Dolphins',
    [NFLTeamAbbreviation.MIN]: 'Vikings',
    [NFLTeamAbbreviation.NE]: 'Patriots',
    [NFLTeamAbbreviation.NO]: 'Saints',
    [NFLTeamAbbreviation.NYG]: 'Giants',
    [NFLTeamAbbreviation.NYJ]: 'Jets',
    [NFLTeamAbbreviation.PHI]: 'Eagles',
    [NFLTeamAbbreviation.PIT]: 'Steelers',
    [NFLTeamAbbreviation.SEA]: 'Seahawks',
    [NFLTeamAbbreviation.SF]: '49ers',
    [NFLTeamAbbreviation.TB]: 'Buccaneers',
    [NFLTeamAbbreviation.TEN]: 'Titans',
    [NFLTeamAbbreviation.WAS]: 'Commanders',
    [NFLTeamAbbreviation.DEFAULT]: '',
};
